 
 
export default class Navigation extends HTMLElement {
  connectedCallback() {
    this.render();
  }
  render() {
        this.innerHTML = `<nav>
        <ul class="navigation-LKgK1vki-list">
          <li class="navigation-LKgK1vki-listItem">
            <h2 class="navigation-LKgK1vki-heading">
              <a class="navigation-LKgK1vki-link" href="/artists/">
                artists
              </a>
            </h2>
          </li>

          <li class="navigation-LKgK1vki-listItem">
            <h2 class="navigation-LKgK1vki-heading">
              <a class="navigation-LKgK1vki-link" href="/albums/">
                albums
              </a>
            </h2>
          </li>

          <li class="navigation-LKgK1vki-listItem">
            <h2 class="navigation-LKgK1vki-heading">
              <a class="navigation-LKgK1vki-link" href="/events/">
                events
              </a>
            </h2>
          </li>

          <li class="navigation-LKgK1vki-listItem">
            <h2 class="navigation-LKgK1vki-heading">
              <a class="navigation-LKgK1vki-link" href="/contact/">
                contact
              </a>
            </h2>
          </li>
        </ul>
      </nav>`;

  }
}
customElements.define("as-navigation", Navigation);
